import React from "react";

export default function ProductSEO({
    product,
    setProduct
}) {

    const update = (field, value) => {

        setProduct(prev => ({
            ...prev,
            [field]: value
        }));

    };

    return (

        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: 24
            }}
        >

            <div>

                <h2
                    style={{
                        margin: 0
                    }}
                >
                    SEO
                </h2>

                <p
                    style={{
                        color: "#666",
                        marginTop: 8
                    }}
                >
                    Optimize how your product appears in search
                    engines and social discovery.
                </p>

            </div>

            <div
                style={{
                    background: "#fff",
                    borderRadius: 16,
                    padding: 24,
                    border: "1px solid #e5e7eb"
                }}
            >

                <div>

                    <label
                        style={{
                            fontWeight: 600
                        }}
                    >
                        SEO Title
                    </label>

                    <input
                        value={product.seoTitle || ""}
                        onChange={e =>
                            update(
                                "seoTitle",
                                e.target.value
                            )
                        }
                        placeholder={
                            product.title ||
                            "Search engine title"
                        }
                        maxLength={70}
                        style={inputStyle}
                    />

                    <div
                        style={{
                            marginTop: 6,
                            fontSize: 12,
                            color: "#888"
                        }}
                    >
                        {(product.seoTitle || "").length}/70
                    </div>

                </div>

                <div
                    style={{
                        marginTop: 24
                    }}
                >

                    <label
                        style={{
                            fontWeight: 600
                        }}
                    >
                        Meta Description
                    </label>

                    <textarea
                        value={
                            product.seoDescription || ""
                        }
                        onChange={e =>
                            update(
                                "seoDescription",
                                e.target.value
                            )
                        }
                        placeholder={
                            product.shortDescription ||
                            "Describe this product for search engines..."
                        }
                        maxLength={160}
                        rows={5}
                        style={{
                            ...inputStyle,
                            resize: "vertical"
                        }}
                    />

                    <div
                        style={{
                            marginTop: 6,
                            fontSize: 12,
                            color: "#888"
                        }}
                    >
                        {(product.seoDescription || "").length}/160
                    </div>

                </div>

            </div>

            {/* Search Preview */}

            <div
                style={{
                    background: "#fff",
                    borderRadius: 16,
                    padding: 24,
                    border: "1px solid #e5e7eb"
                }}
            >

                <h3
                    style={{
                        marginTop: 0
                    }}
                >
                    Search Preview
                </h3>

                <div
                    style={{
                        padding: 20,
                        borderRadius: 12,
                        background: "#f9fafb"
                    }}
                >

                    <div
                        style={{
                            color: "#1a0dab",
                            fontSize: 19,
                            fontWeight: 500
                        }}
                    >
                        {product.seoTitle ||
                            product.title ||
                            "Product title"}
                    </div>

                    <div
                        style={{
                            color: "#555",
                            marginTop: 8,
                            lineHeight: 1.5
                        }}
                    >
                        {product.seoDescription ||
                            product.shortDescription ||
                            "Product description"}
                    </div>

                </div>

            </div>

            <div
                style={{
                    padding: 18,
                    borderRadius: 10,
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    color: "#64748b"
                }}
            >
                Open Graph image is not currently represented
                by a field in your PocketBase products collection.
            </div>

        </div>

    );

}

const inputStyle = {

    width: "100%",
    boxSizing: "border-box",
    marginTop: 8,
    padding: "12px 14px",
    borderRadius: 10,
    border: "1px solid #d1d5db",
    fontSize: 15

};